module.exports = __webpack_public_path__ + "media/images/mypage/mypage_title_bg-90b65c8cd5f21817ece1699806abeb43.png";